import { ardoqAccessSpecs } from './ardoqAccessSpecs';
import { compileCanDoFn } from './compileCanDoFn';

/**
 * Check if user has permission to perform a particular privilege.
 * Usage:
 * ```ts
 * import currentUserPermissionContext$ from 'streams/currentUserPermissions/currentUserPermissionsContext$';
 *
 * const isAllowed = canDo({
 *   action: 'workspace/create_component',
 *   resourceId: workspaceId,
 *   permissionsContext, // <- from currentUserPermissionContext$ or currentUserInterface.getPermissionContext()
 * });
 * ```
 *
 * Note that `canDo` is very narrowly defined and cannot distinguish
 * between creating components in scenario mode or not. For cases where more
 * logic is required another layer should be built on top of canDo with
 * strict and guiding types. eg.
 * ```ts
 * canCreateComponent({
 *   workspaceId,
 *   scenarioId: null,
 *   permissionsContext,
 * })
 * ```
 */
export const canDo = compileCanDoFn(ardoqAccessSpecs);
export type CanDoAction = keyof typeof ardoqAccessSpecs;
